if (!customElements.get("add-cart-button")) {
  class AddCartButton extends HTMLElement {
    // 标记
    _marks = {
      loading: "loading",
    };

    _shopify_features_script = document.querySelector(
      "script[id='shopify-features']"
    );
    _shopify_features_json = JSON.parse(
      this._shopify_features_script.innerHTML
    );
    _checkout_headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
      authorization: "Basic " + btoa(this._shopify_features_json.accessToken),
    };

    get _variantId() {
      return this.getAttribute("data-variant-id");
    }
    get _quantity() {
      return this.getAttribute("data-quantity") ?? 1;
    }

    constructor() {
      super();
      this._onClick = this._onClick.bind(this);
      this._processing = false;
    }

    connectedCallback() {

      this.setAttribute("aria-label", "Add to Cart");
      this.setAttribute("role", "button");
      this.setAttribute("tabindex", "0");

      this.updateQuantity();
      this.elements = {
        loadingSpinner: this.querySelector(".loading__spinner"),
      };
      this.addEventListener("click", this._onClick);
      this.addEventListener("keydown", (e) => {
        if (e.type === 'keydown' && e.key !== "Enter" && e.key !== " ") {
          return; 
        }
        this._onClick();
      });
    }

    disconnectedCallback() {
      this.removeEventListener("click", this._onClick);
    }

    isSaleClosed() {
      if (this.getAttribute('data-sale-gated') !== 'true') return false;
      const section = this.closest('[data-sale-open]');
      if (!section) return true;
      return section.getAttribute('data-sale-open') !== 'true';
    }

    _onClick(e) {
      if (this.isSaleClosed()) return;
      if (this._processing) return;
      this._processing = true;
      this.startLoading();
      Promise.resolve(this.addToCart())
        .catch((err) => console.error(err))
        .finally(() => {
          this.finishLoading();
          this._processing = false;
        });
    }

    updateQuantity() {
      const mainQtyElement = document.querySelector('.product-form__main_quantity');

      if (mainQtyElement) {
        const quantityInput = mainQtyElement.querySelector('quantity-input input[name="quantity"]');

        if (quantityInput) {
          const updateDataQuantity = () => {
            const inputValue = quantityInput.value;
            let quantityArray = this.getAttribute('data-quantity').split(',');
            quantityArray[0] = inputValue;
            this.setAttribute('data-quantity', quantityArray.join(','));
          };

          quantityInput.addEventListener('change', updateDataQuantity);

          // 初始化时也更新 data-quantity 的第一位数值
          updateDataQuantity();
        }
      }
    }

    onCartUpdate() {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const targetElement = document.querySelector("cart-drawer");
          const sourceElement = html.querySelector("cart-drawer");
          targetElement.innerHTML = sourceElement.innerHTML;
          targetElement.classList.add("active");
          targetElement.classList.remove("is-empty");
          document.querySelector("body").classList.add("overflow-hidden");
        })
        .catch((e) => {
          console.error(e);
        });

      fetch(`${routes.cart_url}.js`)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((cartData) => {
          const cartItemCount = cartData.item_count;
          let cartCountBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
          if (!cartCountBubble) {
            cartCountBubble = document.createElement('div');
            cartCountBubble.className = 'cart-count-bubble';
            cartCountBubble.innerHTML = `<span aria-hidden="true">${cartItemCount}</span><span class="visually-hidden">${cartItemCount} item</span>`;
            document.querySelector('#cart-icon-bubble').appendChild(cartCountBubble);
          } else {
            cartCountBubble.querySelector('span[aria-hidden="true"]').textContent = cartItemCount;
            cartCountBubble.querySelector('.visually-hidden').textContent = `${cartItemCount} item`;
          }
        })
        .catch((error) => {
          console.error('There has been a problem with your fetch operation:', error);
        });
    }

    /**
     * 加购
     */
    async addToCart() {
      this.updateQuantity();
      const variantIds = this._variantId.split(",");
      const quantities = this._quantity.split(",");

      const defaultQuantity = quantities[0] || 1; // 默认数量为1，如果 quantities 为空
      if (variantIds.length !== quantities.length) {
        console.warn("变体ID与数量的数量不匹配，将使用相同的数量值。");
        quantities.length = variantIds.length; // 将数量数组的长度调整为与变体ID数组相同
        quantities.fill(defaultQuantity); // 用默认数量填充整个数组
      }


      const items = variantIds.map((id, index) => {
        return {
          form_type: "product",
          utf8: "✓",
          id: parseInt(id, 10),
          quantity: parseInt(quantities[index], 10), // 使用对应的数量值
        };
      });

      let data_json = {
        items: items,
      };

      let data = JSON.stringify(data_json);
      return fetch("/cart/add.json", {
        method: "POST",
        headers: this._checkout_headers,
        body: data,
      })
        .then(async (response) => {
          if (response.ok) {
            if (window.cartGiftSettings) {   //如果开启了阶梯满赠，需要更新购物车赠品
              const cartRes = await fetch('/cart.js');
              const cart = await cartRes.json();
              if (window.updateStepCartGift) {
                await window.updateStepCartGift(cart);
              }
              if (window.buyAGetBCartGiftSettings) {
                await window.updateBuyAGetBCartGift(cart);
              }
              if (window.buyAGetBSecondCartGiftSettings) {
                await window.updateBuyAGetBSecondCartGift(cart);
              }
            }
            return response.json();
          } else {
            if (response.status === 422) {
              alert("Inventory shortage!");
            }
            throw new Error("请求失败");
          }
        })
        .then((response) => {
          if (window.timber?.RightDrawer && window.jQuery) {
            window.timber.RightDrawer.$activeSource = window.jQuery(this);
          }
          if (window.ajaxCart && typeof window.ajaxCart.load === "function") {
            window.ajaxCart.load();
          } else if (window.timber?.RightDrawer?.open) {
            window.timber.RightDrawer.open();
          }
          return this.updateCart(response);
        })
        .catch((err) => {
          console.error(err);
        });
    }

    /**
     * 更新购物车，并弹出侧边购物车
     * @returns
     */
    async updateCart(response) {
      this.onCartUpdate();
    }

    startLoading() {
      this.setAttribute("aria-disabled", true);
      this.classList.add(this._marks.loading);
      this.elements.loadingSpinner?.classList.remove("hidden");
    }

    finishLoading() {
      this.removeAttribute("aria-disabled");
      this.classList.remove(this._marks.loading);
      this.elements.loadingSpinner?.classList.add("hidden");
    }
  }

  customElements.define("add-cart-button", AddCartButton);
}
